import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Home from "./pages/Home";
import Layout from "./pages/Layout";
import Weekend from "./pages/Weekend";
import WeekendHome from "./pages/WeekendHome";
import Session from "./pages/Session";
import Login from "./pages/Login";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path=":yearParam">
            <Route index element={<Home />} />
            <Route path=":weekendKey" element={<Weekend />}>
              <Route index element={<WeekendHome />} />
              <Route path=":sessionKey" element={<Session />} />
              <Route path="*" element={<h1>404</h1>} />
            </Route>
            <Route path="*" element={<h1>404</h1>} />
          </Route>
          <Route path="*" element={<h1>404</h1>} />
        </Route>
        <Route path="/about" element={<h1>about</h1>} />
        <Route path="*" element={<h1>404</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
